var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_profile-add",
    "data-name": "vuesax/linear/profile-add",
    transform: "translate(-364 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-add",
    transform: "translate(364 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.333,0H0",
    transform: "translate(30.208 40.625)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,8.333V0",
    transform: "translate(34.375 36.458)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M9.583,18.479a3.787,3.787,0,0,0-.687,0,9.24,9.24,0,1,1,.688,0Z",
    transform: "translate(15.75 4.167)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M14.219,17.979A19.062,19.062,0,0,1,3.781,15.1c-5.042-3.375-5.042-8.875,0-12.229,5.729-3.833,15.125-3.833,20.854,0",
    transform: "translate(10.76 27.458)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H50V50H0Z",
    transform: "translate(50 50) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.18c89faeb3ee667f0a92bf1d9f83cdf8.svg";
export { ForwardRef as ReactComponent };